import { COLORS } from '../../constants/theme';

interface FreshnessCellProps {
  /** The tick at which the intel was captured. Null if no intel. */
  capturedAtTick: number | null;
  /** Current game tick. */
  currentTick: number;
}

/**
 * Renders a freshness indicator showing how many ticks ago intel was captured.
 *
 * Color tiers (1 tick = 1 Utopian day):
 *   ≤12 ticks → green (fresh)
 *   ≤48 ticks → yellow (aging)
 *   >48 ticks → red (stale)
 *   null      → muted "No data"
 */
export function FreshnessCell({ capturedAtTick, currentTick }: FreshnessCellProps) {
  if (capturedAtTick === null) {
    return <span style={{ color: COLORS.text.muted }}>No data</span>;
  }

  const age = Math.max(0, currentTick - capturedAtTick);
  let color: string;
  if (age <= 12) {
    color = COLORS.positive;
  } else if (age <= 48) {
    color = COLORS.warning;
  } else {
    color = COLORS.negative;
  }

  return (
    <span style={{ color, fontVariantNumeric: 'tabular-nums' }}>
      {age === 0 ? 'Today' : `${age}d ago`}
    </span>
  );
}
